import { QUIZ_SCREEN } from 'constants/screens';

import React from 'react';
import { useAppContext, SET_ACTIVE_SCREEN } from 'store';

import { PluginContainerHome } from '@coursera/templates';

import image from '../assets/intro.png';

function IntroContainer() {
  const { dispatch } = useAppContext();
  const next = () => dispatch({ type: SET_ACTIVE_SCREEN, payload: QUIZ_SCREEN });

  return (
    <PluginContainerHome
      header="Find interview participants"
      subheader="In this exercise, you’ll explore various ways to recruit people for UX research projects."
      image={image}
      next={() => next()}
    />
  );
}

export default IntroContainer;
